export const updateScrollPercent = percent => ({
  type: "UPDATE_SCROLL_PERCENT",
  percent
});
